import React, { useState } from 'react';
import { API_URL } from './constants';
import { toast, ToastContainer } from 'react-toastify';
import {validateFeedback} from './VoiceTranscription';
import { submitFeedback } from './APICalls';

const CompactPopupForm = ({ user, open, onClose, setIsFeedbackSubmitted }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    dateOfBirth: '',
    occupation: '',
    designation: '',
    organization: '',
    feedback: '',
    okayWithFeedback: false,
    termsAccepted: false,
    marketingName: '',
    marketingDesignation: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = async () => {
    const newErrors = {};
    
    if (!formData.fullName.trim()) newErrors.fullName = 'Required';
    if (!formData.dateOfBirth) newErrors.dateOfBirth = 'Required';
    // if (!formData.occupation.trim()) newErrors.occupation = 'Required';
    // if (!formData.designation.trim()) newErrors.designation = 'Required';
    if (!formData.organization.trim()) newErrors.organization = 'Required';
    
    if (!formData.feedback.trim()) {
      newErrors.feedback = 'Required';
    } else if(formData.feedback.trim().length < 100) {
      newErrors.feedback = 'Feedback must be at least 100 characters';
    }
    
    if (formData.dateOfBirth){
        const dob = new Date(formData.dateOfBirth);
        const today = new Date();

        const age = today.getFullYear() - dob.getFullYear();
        const monthDiff = today.getMonth() - dob.getMonth();
        const dayDiff = today.getDate() - dob.getDate();

        const is18OrOlder =
          age > 13 || (age === 13 && (monthDiff > 0 || (monthDiff === 0 && dayDiff >= 0)));

        if(!is18OrOlder) {
          newErrors.dateOfBirth = "You need to be atleast 13 years old to download this data."
        }
    }
    
    if (!formData.okayWithFeedback) newErrors.okayWithFeedback = 'Please confirm';
    if (!formData.termsAccepted) newErrors.termsAccepted = 'Please accept terms';
    // if (!formData.marketingName.trim()) newErrors.marketingName = 'Required';
    // if (!formData.marketingDesignation.trim()) newErrors.marketingDesignation = 'Required';
    
    setErrors(newErrors);
    console.log(Object.keys(newErrors));
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (await validateForm()) {
     // setIsSubmitting(true);
      try {
        const result = await submitFeedback(formData, user.accessToken);
        console.log(result);
        // alert('Form submitted successfully:', result);
        if(result.success){
          setIsSubmitted(true);
          // For other component's benefit
          setIsFeedbackSubmitted(true);
          toast.success("Thank you for your feedback. You can now proceed with the download.");
          handleReset();
          // Close the modal after successful submission
          if (onClose) {
            setTimeout(() => {
              onClose();
            }, 2000); // Close after 2 seconds to show success message
          }
        }
        else{
          setIsSubmitted(false);
          toast.error(result.error);
        }
      } catch (error) {
        // console.error('Failed to submit form:', error);
        // // You can add error handling here, such as showing an error message
        // toast.error("Failed to submit feedback. Please try later.");
        console.log(error);
        if (error.response && error.response.status === 400) {
        // Specific message for 400 errors
          toast.error(error.response.data?.message || "Bad request. Please check your input.");
        } else {
            // Generic error handler
            console.error('Failed to submit form:', error);
            toast.error("Please provide valid feedback.");
        }
        setErrors({ submit: 'Failed to submit form. Please try again.' });
      } finally {
      }
    }
  };

  const handleReset = () => {
    setFormData({
      fullName: '',
      dateOfBirth: '',
      occupation: '',
      designation: '',
      organization: '',
      feedback: '',
      okayWithFeedback: false,
      termsAccepted: false,
      marketingName: '',
      marketingDesignation: ''
    });
    setErrors({});
    setIsSubmitted(false);
  };

  // Remove backdrop click to close functionality

  if (!open) return null;

  if (isSubmitted) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="w-full max-w-md bg-white rounded-lg shadow-2xl p-6 relative">
          <div className="text-center">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-lg font-semibold text-gray-800 mb-2">Success!</h2>
            <p className="text-sm text-gray-600 mb-4">Details submitted successfully.</p>
            {/* <button
              onClick={() => {
                handleReset();
                // Don't close the modal, just reset for another submission
              }}
              className="bg-blue-600 text-white px-4 py-2 rounded text-sm hover:bg-blue-700 transition-colors"
            >
              Submit Another
            </button> */}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow-2xl p-6 relative max-h-[90vh] overflow-y-auto">
        <div className="mb-4">
          <h1 className="text-lg font-semibold text-gray-800 mb-1">Please give your valuable feedback</h1>
          {/* <div className="relative inline-block">
              <button
                type="button"
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                onClick={() => setShowTooltip(!showTooltip)}
                className="w-4 h-4 rounded-full bg-blue-500 text-white text-xs flex items-center justify-center hover:bg-blue-600 transition-colors cursor-help"
              >
                ?
              </button>
              {showTooltip && (
                <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-64 bg-gray-800 text-white text-xs rounded-lg px-3 py-2 shadow-lg z-10">
                  <div className="text-center">
                    <p className="font-medium mb-1">Why do we need this information?</p>
                    <p className="text-gray-200">
                      Your details help us provide personalized responses, 
                      and ensure the authenticity of feedback for marketing purposes (with your consent).
                    </p>
                  </div>
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-gray-800"></div>
                </div>
              )}
            </div> */}
          <p className="text-xs text-gray-600">Please fill out the required information</p>
        </div>

        <div className="space-y-4">
          {/* Personal Info */}
          <div className="space-y-3">
            <div>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleInputChange}
                className={`w-full px-3 py-2 text-sm border rounded focus:outline-none focus:ring-1 focus:ring-blue-500 ${
                  errors.fullName ? 'border-red-500' : 'border-gray-300'
                }`}
                placeholder="Full Name *"
              />
              {errors.fullName && <p className="text-red-500 text-xs">{errors.fullName}</p>}
            </div>

            <div>
              <input
                type="date"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleInputChange}
                className={`w-full px-3 py-2 text-sm border rounded focus:outline-none focus:ring-1 focus:ring-blue-500 ${
                  errors.dateOfBirth ? 'border-red-500' : 'border-gray-300'
                }`}
              />
              {errors.dateOfBirth && <p className="text-red-500 text-xs">{errors.dateOfBirth}</p>}
            </div>
          </div>

          {/* Professional Info */}
          <div className="space-y-3">
            {/* <div>
              <input
                type="text"
                name="occupation"
                value={formData.occupation}
                onChange={handleInputChange}
                className={`w-full px-3 py-2 text-sm border rounded focus:outline-none focus:ring-1 focus:ring-blue-500 ${
                  errors.occupation ? 'border-red-500' : 'border-gray-300'
                }`}
                placeholder="Occupation *"
              />
              {errors.occupation && <p className="text-red-500 text-xs">{errors.occupation}</p>}
            </div> */}

            {/* <div>
              <input
                type="text"
                name="designation"
                value={formData.designation}
                onChange={handleInputChange}
                className={`w-full px-3 py-2 text-sm border rounded focus:outline-none focus:ring-1 focus:ring-blue-500 ${
                  errors.designation ? 'border-red-500' : 'border-gray-300'
                }`}
                placeholder="Designation *"
              />
              {errors.designation && <p className="text-red-500 text-xs">{errors.designation}</p>}
            </div> */}

            <div>
              <input
                type="text"
                name="organization"
                value={formData.organization}
                onChange={handleInputChange}
                className={`w-full px-3 py-2 text-sm border rounded focus:outline-none focus:ring-1 focus:ring-blue-500 ${
                  errors.organization ? 'border-red-500' : 'border-gray-300'
                }`}
                placeholder="Organization *"
              />
              {errors.organization && <p className="text-red-500 text-xs">{errors.organization}</p>}
            </div>
          </div>

          {/* Feedback */}
          <div>
            <textarea
              name="feedback"
              value={formData.feedback}
              onChange={handleInputChange}
              rows="4"
              className={`w-full px-3 py-2 text-sm border rounded focus:outline-none focus:ring-1 focus:ring-blue-500 ${
                errors.feedback ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="Please provide your feedback on the generated dataset and your experience of our platform (min 3 lines) *"
            />
            {errors.feedback && <p className="text-red-500 text-xs">{errors.feedback}</p>}
          </div>

          <div>
            <label className="flex items-start space-x-2">
              <input
                type="checkbox"
                name="okayWithFeedback"
                checked={formData.okayWithFeedback}
                onChange={handleInputChange}
                className="mt-0.5 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <span className="text-xs text-gray-700">
                I am okay with the feedback provided being used for marketing purposes *
              </span>
            </label>
            {errors.okayWithFeedback && <p className="text-red-500 text-xs">{errors.okayWithFeedback}</p>}
          </div>

          <div>
            <label className="flex items-start space-x-2">
              <input
                type="checkbox"
                name="termsAccepted"
                checked={formData.termsAccepted}
                onChange={handleInputChange}
                className="mt-0.5 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <span className="text-xs text-gray-700">
                I have read and understood the <a href="/terms-and-privacy" target='_blank' className="underline text-blue-600 hover:text-blue-800">terms and conditions</a> *
              </span>
            </label>
            {errors.termsAccepted && <p className="text-red-500 text-xs">{errors.termsAccepted}</p>}
          </div>

          {/* Marketing Info */}
          <div className="space-y-3">
            {/* <div>
              <input
                type="text"
                name="marketingName"
                value={formData.marketingName}
                onChange={handleInputChange}
                className={`w-full px-3 py-2 text-sm border rounded focus:outline-none focus:ring-1 focus:ring-blue-500 ${
                  errors.marketingName ? 'border-red-500' : 'border-gray-300'
                }`}
                placeholder="Marketing Name *"
              />
              {errors.marketingName && <p className="text-red-500 text-xs">{errors.marketingName}</p>}
            </div> */}

            {/* <div>
              <input
                type="text"
                name="marketingDesignation"
                value={formData.marketingDesignation}
                onChange={handleInputChange}
                className={`w-full px-3 py-2 text-sm border rounded focus:outline-none focus:ring-1 focus:ring-blue-500 ${
                  errors.marketingDesignation ? 'border-red-500' : 'border-gray-300'
                }`}
                placeholder="Marketing Designation *"
              />
              {errors.marketingDesignation && <p className="text-red-500 text-xs">{errors.marketingDesignation}</p>}
            </div> */}
          </div>

          {/* Submit Button */}
          <div className="pt-2">
            <button
              type="button"
              onClick={handleSubmit}
              className="w-full bg-blue-600 text-white py-2 px-4 rounded text-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors font-medium"
            >
              Submit Details
            </button>
          </div>
        </div>
        {/* <ToastContainer position="top-center" autoClose={3000} /> */}
      </div>
    </div>
  );
};

export default CompactPopupForm;